module.exports = __webpack_public_path__ + "img/061-rain-4.e1a47385.svg";